import styled from 'react-emotion'

export const Layout = styled.div(
  {
    height: '100vh',
    width: '100%',
    backgroundColor: 'grey',
    backgroundSize: 'cover !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    padding: 50,
    fontFamily: "'Josefin Sans', sans-serif",
  },
  ({ fontSize }) => ({
    fontSize: fontSize ? fontSize : 14,
  })
)



// WEBPACK FOOTER //
// ./src/components/Home/styles/StyledHome.js